<template>
    <Layout>
        <b-card v-if="Object.keys(ses).length !== 0">
            <div class="print-size" style="margin: 10mm 20mm 20mm 20mm;">
              <div class="row">
                <div class="col-md-12" style="margin-bottom: 20px;">
                  <div class="col-md-4 float-left">
                    <div class="user-img">
                      <img v-if="ses.profile_picture"
                          :src="ses.profile_picture.name"
                          alt="profile-picture" height="180px" width="180px"
                      />
                    </div>
                  </div>
                  <div :class="ses.profile_picture ==  null ? ' offset-md-2' : ''" class="col-md-8">
                    <h4 class="text-center text-bold" style="text-transform:uppercase">Padma Bridge Rail Link Project(PBRLP),Phase-||(Bhanga - Jashore)</h4>
                    <h5 class="text-center text-bold">RESETTLEMENT UNIT</h5>
                    <h5 class="text-center text-bold" style="margin-top:0px">ENTITLEMENT CARD [EC]</h5>
                    <h6 class="text-center text-bold">TITLED/NON TITLED</h6>
                  </div>
                </div>
                <div class="col-md-12" style="margin-bottom: 20px;">
                  <a class="btn btn-info btn-sm customButton mr-1" @click="printWindow()" href="javascript:void(0);" title="Print this page">Print this page</a>
                </div>
              </div>
              <div>
                <table class="table borderNone table-centered"  style="color: black">
                  <tbody>
                  <tr>
                    <td style="min-width:200px"><b>Household ID:</b> [{{ ses.household_number }}]</td>
                    <td><b>EP ID:</b> [{{ epModify(ses.ep_id.ep_id) }}]</td>
                    <td><b>NID: </b>{{ ses.nid }}</td>
                  </tr>
                  <tr>
                    <td><b>Name of the EP:</b> {{ ses.name }}</td>
                    <td><b>Father/Husband Name:</b>{{ ses.father_husband_name }}</td>
                    <td><b>Mother's Name:</b> {{ ses.mother_name }}</td>
                  </tr>
                  <tr>

                    <td><b>Mobile Number:</b> {{ ses.mobile }}</td>
                    <td><b>Village/Ward: </b>{{  ses.present_address ? ses.present_address.village : ses.village.village_desc }}</td>
                    <td><b>Mouza: </b>{{  ses.present_address ? ses.present_address.mouza : ses.mouza.mouza_desc }}</td>
                  </tr>
                  <tr>
                    <td><b>Union/City Corporation: </b>{{ ses.present_address ? ses.present_address.union_ward : ses.union.union_desc }}</td>
                    <td><b>Upazila: </b>{{ ses.present_address ? ses.present_address.upazila : ses.upazila.upazila_desc }}</td>
                    <td><b>District:</b> {{ ses.present_address ? ses.present_address.district : ses.district.district_desc }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <h5 class="font-weight-bold">A. Acquired Land:</h5>
                <table class="table table-centered table-bordered"  style="color: black">
                  <thead>
                  <tr>
                    <th>SL No.</th>
                    <th>LA Case No.</th>
                    <th>Dag No.</th>
                    <th>Type of Land</th>
                    <th>Acquired Land (Decimal)</th>
                    <th>Price From DC Office</th>
                    <th>Price from PVAC</th>
                    <th>Top-up</th>
                  </tr>
                  </thead>
                  <tbody v-if="payment_lands.length > 0">
                  <tr v-for="(payment_land, index) in payment_lands" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ payment_land.land.ccl_land.ccl.la_case ? payment_land.land.ccl_land.ccl.la_case.la_case_desc : '' }}</td>
                    <td>{{ payment_land.land.plot_no }}</td>
                    <td>{{ payment_land.land_type ? payment_land.land_type.land_type_desc : '' }}</td>
                    <td>{{ payment_land.current_self_affected }}</td>
                    <td>{{ parseFloat(payment_land.current_ccl_amount).toFixed(2) }}</td>
                    <td>{{ payment_land.current_pvac_amount }}</td>
                    <td>{{ payment_land.current_agl }}</td>
                  </tr>
                  </tbody>
                  <tfoot v-if="payment_lands.length > 0">
                  <tr>
                    <td style="padding: 4px !important;" colspan="4"><span class="font-weight-bold float-right" style="font-size:15px;">Total</span></td>
                    <td class="font-weight-bold">{{ total_land_info.total_land }}</td>
                    <td class="font-weight-bold">{{ total_land_info.total_ccl }}</td>
                    <td class="font-weight-bold">{{ total_land_info.total_pvac_amount }}</td>
                    <td class="font-weight-bold">{{ total_land_info.total_AGL }}</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
              <div style="margin-top: 14px !important;">
                <h5 class="font-weight-bold">B. Resettlement Benefits:</h5>
                <table class="table table-centered table-bordered"  style="color: black">
                  <thead>
                  <tr>
                    <th style="min-width:38px">Sl No.</th>
                    <th>Entitlement</th>
                    <th style="min-width: 130px">Code</th>
                    <th style="min-width: 100px">Amount (TK.)</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[1] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[1] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[1] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_AGL).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[2] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[2] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[2] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_AGWB).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[3] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[3] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[3] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_RRC).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[4] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[4] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[4] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_AGS).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[5] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[5] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[5] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_TG).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[6] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[6] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[6] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_RG).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[7] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[7] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[7] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_TG_PCR_CPR).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[8] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[8] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[8] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_DRG_PCR_CPR).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[9] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[9] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[9] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_AGT).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[10] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[10] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[10] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGVFT).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[11] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[11] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[11] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGSCFS).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[12] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[12] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[12] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGSLL).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[13] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[13] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[13] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_RVS).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[14] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[14] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[14] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGEE).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[15] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[15] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[15] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_RARO).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[16] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[16] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[16] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_RARI).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[17] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[17] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[17] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_MG).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[18] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[18] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[18] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGVMH).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[19] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[19] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[19] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGVFH).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[20] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[20] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[20] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGNUC).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[21] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[21] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[21] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGIDCIP).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[22] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[22] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[22] }}</td>
                    <td>{{ parseFloat(parent_payment_voucher.amount_CGLIP).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td>{{ parent_payment_voucher.entitledSlRoman[23] }}</td>
                    <td>{{ parent_payment_voucher.entitledDesc[23] }}</td>
                    <td>{{ parent_payment_voucher.entitledShortCode[23] }}</td>
                    <td>0.00</td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td></td>
                    <td></td>
                    <td style="padding: 4px !important;" class="font-weight-bold">Total : </td>
                    <td style="padding: 4px !important;" class="font-weight-bold">{{ parent_payment_voucher.total_amount }}</td>
                  </tr>
                  </tbody>
                </table>
                <table class="table table-borderless" style="margin-top: 5px !important; color: black">
                  <tbody>
                  <tr>
                    <td style="max-width:300px"><span class="font-weight-bold">Total Taka in Word: </span>{{ parent_payment_voucher.inWordTaka }} </td>
                    <td><span class="font-weight-bold">Cheque No.:</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td><span class="font-weight-bold">Dated:</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  </tr>
                  </tbody>
                </table>
                <table class="table table-borderless" style="margin-top: -20px; color: black">
                  <tbody>
                  <tr>
                    <td>
                      <br><br><br>
                      <p style="color: gray; margin-bottom: -2px;">--------------------------------------------------------------------------------------</p>
                      <b>Signature of TL/DTL, PBRLP, Phase-|| <br>
                        DORP-Resettlement
                      </b>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </b-card>
        <b-card v-if="Object.keys(parent_payment_voucher).length == 0">
          <h3 class="dorp-blink checkInvalid">Payment Voucher Not Found. Try Again!!</h3>
        </b-card>
    </Layout>
</template>

<script>
    import moment from "moment";
    import Datepicker from "vuejs-datepicker";
    import Multiselect from "vue-multiselect";
    import substr_replace from "@views/asset/js/substr_replace"

    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "EP Voucher",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "EP Voucher",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'EP Voucher',
                        active: true,
                    },
                ],
                ses: {},
                parent_payment_voucher: {},
                total_land_info: {},
                payment_lands: {},
                amount: '',
                inWordTaka: '',
            };
        },

        mounted() {
            // let payment_voucher_id = this.$route.params.payment_voucher_id;
            this.getEcVoucher();
        },

        methods: {
            epModify(ep_id){
                var split_string = ep_id.toString()
                return substr_replace(split_string, '#', 5, 0)
            },
            getEcVoucher() {
                let power_group_id = this.$route.params.power_group_id;
                http.get("api/group/ec/voucher/" + power_group_id).then(response => {
                    if (!response.error) {
                        this.ses = response.data.ses;
                        this.parent_payment_voucher = response.data.parent_payment_voucher;
                        this.total_land_info = response.data.total_land_info;
                        this.payment_lands = response.data.payment_lands;
                        this.amount = parseFloat(response.data.parent_payment_voucher.total_amount).toFixed(2)
                        this.inWordTaka = response.data.parent_payment_voucher.inWordTaka
                    }
                });
            },
            printWindow() {
              window.print();
            }
        },

    };
</script>

<style scoped>
.table th, .table td {
  padding: 4px !important;
}
@media print {
  .customButton {
    display: none;
  }
}
.table{
  margin-bottom: 0px !important;
}
.borderNone{
  border: none !important;
}
.borderNone th, .borderNone td {
  border-top: none !important;
}
@media print {
  body {
    width: 21cm;
    height: 29.7cm;
  }

}
@page {
  margin-top: 5px;
}
.print-size {
  font-family: Arial, Helvetica, sans-serif;
  /*display: inline;*/
  /*width: 27.8cm;*/
  /*height: 29.7cm;*/
  /*width: 27.8cm;*/
  /*height: 450px;*/
}
td b{
  font-weight: bold !important;
}
</style>
